import $ from 'jquery';
import { gridSwatches, swatchClicks } from '../exports/swatches';
import { register } from './../exports/theme-sections';

const relatedSection = {
  onLoad: function() {
    var $relatedSection = $(this.container);
    var relatedSection = this.container;
    var productId = $relatedSection.data('product-id');
    var limit = $relatedSection.data('limit');
    var requestRoute = window.theme.routes.product_recommendations_url || '/recommendations/products/';
    var requestUrl = `${requestRoute}?section_id=related&limit=${limit}&product_id=${productId}`;

    $.get(requestUrl)
      .done(function(data) {
        var inner = $(data).find('[data-related-section]').html();
        $relatedSection.hide().html(inner).slideDown('slow');
        const swatches = relatedSection.querySelectorAll('[data-grid-swatches]');
        swatches.forEach(swatch => {
          gridSwatches(swatch).then(() => {
            swatchClicks(swatch);
          });
        });
      });
  },
};

register('related', relatedSection);
